import { Box } from "@mui/material";
import { FC } from "react";
import { useGroupHeaderStyle } from "../../../style/group-header.style";

export const GroupDetailHeader: FC<React.PropsWithChildren> = (props) => {
  const { children } = props;
  const { classes: headerStyle } = useGroupHeaderStyle();

  return <Box className={headerStyle.detailHeader}>{children}</Box>;
};
